/**
 * 集团营收 KPI 环比前缀：随 PeriodDateFilter 周期变化，自定义区间不展示环比文案
 */
import type { PeriodDateFilterValue } from '../component/period-date-filter.component';

/**
 * 根据当前日期筛选周期返回环比前缀 i18n key；custom 等无对比基准时返回 null
 * @param period - 由 getPeriodFromDates 推导的周期
 */
export function getGroupRevenueComparePeriodLabelKey(
    period: PeriodDateFilterValue,
): string | null {
    switch (period) {
        case 'this_week':
            return 'group_revenue_analysis_vs_last_week';
        case 'today':
            return 'group_revenue_analysis_vs_last_day';
        case 'this_month':
            return 'group_revenue_analysis_vs_last_month';
        default:
            return null;
    }
}

/**
 * 格式化接口环比百分比用于展示（无正负号时补 +）
 * @param raw - 接口 mom_percent 等字段
 */
export function formatGroupRevenueMomPercent(raw: string | null | undefined): string {
    if (raw == null) return '';
    const s = String(raw).trim();
    if (!s) return '';
    if (s.startsWith('+') || s.startsWith('-')) return s;
    return `+ ${s}`;
}
